<script>
	import "./styles/login.scss";
	import "./styles/styles.scss";

	export default {
		name: "App",
		mounted() {},
	};
</script>

<template>
	<router-view />
</template>
